module.exports = __webpack_public_path__ + "img/media-8.2baef355.png";